import styled from 'styled-components';

import { GenericDiv, ClickText, FlexDiv } from 'commonStyles';

export const Wrapper = styled(GenericDiv)`
	border-bottom: ${(props) => props.showBdr ? '1px solid #D6D6D8' : ''};
`;

export const SupportWrap = styled(ClickText)`
	position: absolute;
	right: calc(50% - 600px);;
	top: 12px;
	z-index: 10;
`;

export const HeaderWrap = styled(FlexDiv)`
	top: 0;
	left:0;
	z-index: 5;
`;
